exports = module.exports = require("../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-2967324c]{margin-bottom:1rem;font-size:1.25rem}h2[data-v-2967324c]{margin-top:1.5rem;font-weight:600}h2[data-v-2967324c],p[data-v-2967324c]{margin-bottom:.5rem}ul[data-v-2967324c]{margin-left:2rem;margin-top:1rem;margin-bottom:1rem;list-style-type:disc}", ""]);

// exports
